export const isinWarningString = "ISIN must begin with 2 letters, followed by 10 alphanumeric characters";
export const isinRegex = /^[A-Z]{2}[A-Z0-9]{10}$/;

export const assetCodeWarningString = "Must provide valid asset code eg. AB3.EX4";
export const assetCodeRegex = /^[A-Z0-9]{1,9}[.][A-Z0-9]{1,9}$/;
